import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#0f2027',
                    color: '#fff',
                    fontFamily: 'Segoe UI, sans-serif',
                    textAlign: 'center',
                    padding: '2rem',
                }}>
                    <div style={{ fontSize: '4rem' }}>⚠️</div>
                    <h1 style={{ fontSize: '1.8rem', margin: '1rem 0 0.5rem' }}>Something went wrong</h1>
                    <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: '400px', marginBottom: '1.5rem' }}>
                        An unexpected error occurred. Please refresh the page or try again later.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '0.7rem 1.8rem',
                            background: 'linear-gradient(135deg,#43e97b,#38f9d7)',
                            border: 'none',
                            borderRadius: '50px',
                            color: '#0f2027',
                            fontWeight: '700',
                            fontSize: '1rem',
                            cursor: 'pointer',
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
